import React from 'react';
import Memory from "@material-ui/icons/Memory";
import Tooltip from "@material-ui/core/Tooltip";

interface ISensorIconProps {
    show: boolean;
    color: string;
}

export const SensorIcon = (props: ISensorIconProps) => {
    const { show, color } = props;
    if (!show) {
        return null;
    }
    return (
        <Tooltip title="Sensor">
            <div style={{color: color}}>
                <Memory/>
            </div>
        </Tooltip>
    );
};

export default SensorIcon;
